import styled, { css } from 'styled-components';
import { darken } from 'polished';
import Colors from '../../theme/Colors';

interface ContainerProps {
  hasImage: boolean;
}

export const InputContainer = styled.div`
  input {
    font-size: 14px;
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border-color: #e8e8e8;
    outline: none;
  }
`;

export const DeleteButton = styled.button`
  background-color: ${Colors.pink} !important;
  border-bottom: 4px solid ${darken(0.25, Colors.pink)} !important;

  span {
    width: 100%;
  }
`;

export const Container = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 16px;

  width: 100%;
  height: 100%;
  max-width: 1032px;
  max-height: 532px;

  @media (max-width: 845px) {
    max-width: 532px;
  }

  ${props =>
    !props.hasImage &&
    css`
      max-width: 532px;
    `}

  margin: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${Colors.grayDark};

  > div {
    height: 100%;
    width: 100%;
    max-width: 100%;
    background-color: #fff;
    border-radius: 16px;
    padding: 1.25rem;

    display: grid;
    grid-template-columns: 1fr 1.2fr;
    min-height: 90vh;

    @media (max-width: 845px) {
      grid-template-columns: 1fr;
    }

    ${props =>
      !props.hasImage &&
      css`
        grid-template-columns: 1fr;
      `}
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  z-index: 99;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 450px;

  @media (max-width: 845px) {
    display: none;
  }

  img {
    max-width: 300px;
    width: 100%;
    height: 100%;
    max-height: 300px;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const Details = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 87vh;
  /* max-height: calc(100% - 400px); */
  position: relative;

  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${Colors.grayDark};
    padding-bottom: 8px;
  }

  > header > button {
    background-color: transparent;
    font-size: 24px;
    color: ${Colors.grayDark};
  }

  > main {
    /* display: flex; */
    /* flex-direction: column; */
    max-height: 100%;
    overflow: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  > main > p {
    font-size: 12px;
    color: #717171;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  > main > strong {
    font-size: 12px;
    color: ${Colors.green};
  }

  > main > hr {
    margin: 12px 0;
  }

  > footer {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    padding-top: 16px;

    @media (max-width: 490px) {
      flex-direction: column;
    }
  }

  > footer > section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 64px;
    padding-left: 16px;

    @media (max-width: 490px) {
      max-width: 150px;
      padding-left: 0;
      margin: 0 auto;
    }
  }

  > footer > section {
    display: flex;
    align-items: center;

    input {
      width: 55px;
      text-align: center;
      font-size: 16px;
      border: none;
      outline: none;
      font-weight: bold;
    }

    button {
      width: 35px;
      height: 35px;
      border-radius: 4px;
      background-color: ${Colors.secondary};
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      outline: none;
    }

    button:disabled {
      opacity: 0.5;
    }
  }

  > footer > button {
    margin-left: auto;
    width: 50%;
    padding: 12px;
    border-radius: 8px;
    background-color: ${Colors.secondary};
    color: #fff;
    font-weight: bold;
    border-bottom: 4px solid ${darken(0.25, Colors.secondary)};
    outline: none;
    font-size: 14px;

    display: flex;
    justify-content: space-between;

    @media (max-width: 490px) {
      width: 100%;
      margin-top: 16px;
    }
  }

  > footer > button:disabled {
    opacity: 0.5;
  }
`;

export const ComplementContainer = styled.section`
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f2f2f2;
    padding: 8px 16px;
    position: sticky;
    top: 0;
  }

  header > div > strong {
    font-size: 14px;
  }

  header > div > p {
    margin: 0;
    font-size: 12px;
  }

  header > span {
    background-color: #717171;
    border-radius: 4px;
    color: #fff;
    font-size: 8px;
    text-transform: uppercase;
    font-weight: bold;
    padding: 2px 4px;
  }
`;

export const ComplementItem = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  margin: 0;

  > div > p {
    margin: 0;
    font-size: 14px;
  }

  > div > strong {
    font-size: 12px;
  }

  input[type='checkbox'] {
    appearance: none;
    width: 24px;
    height: 24px;
    border-color: ${Colors.secondary};
    border: 2px solid ${Colors.secondary};
    cursor: pointer;
    border-radius: 4px;
  }

  input[type='checkbox']:checked {
    background-color: ${Colors.secondary};
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
  }

  input[type='radio'] {
    appearance: none;
    width: 24px;
    height: 24px;
    border: 2px solid ${Colors.secondary};
    border-radius: 50%;
    background-clip: content-box;
    padding: 3px;
    cursor: pointer;
    outline: none;
  }

  input[type='radio']:checked {
    background-color: ${Colors.secondary};
  }
`;

export const QuantityContainer = styled.section`
  display: flex;
  align-items: center;

  input {
    width: 55px;
    text-align: center;
    font-size: 16px;
    border: none;
    outline: none;
    font-weight: bold;
  }

  button {
    width: 35px;
    height: 35px;
    border-radius: 4px;
    background-color: ${Colors.secondary};
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
  }
`;

export const TextareaContainer = styled.div`
  label {
    font-size: 14px;
    margin: 0;
    font-weight: bold;
  }

  textarea {
    font-size: 14px;
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border-color: #e8e8e8;
    outline: none;
  }
`;

export const GroupTitle = styled.h4`
  font-size: 14px;
  font-weight: bold;
  color: ${Colors.grayDark};
  margin: 16px 0 8px 16px;
  padding: 4px 0;
  border-bottom: 1px solid #e8e8e8;
`;
